export default function tradeRewardsNav() {
    return import(
        /* webpackChunkName: "tradeRewardsNav" */
        './RewardsNav'
    ).then(mod => {
        return mod.RewardsNav;
    });
}
